import { createStore } from 'vuex'

export default createStore({
  state: {
    tags: [],
    imageInfos: {
      "picture_id": "",
      "title": "",
      "width": 2438,
      "height": 4093,
      "regular_url": "",
      "original_url": "",
      "page_total": 1,
      "status": 5,
      "type": 0,
      "like_total": 0,
      "comment_total": 0,
      "tags": "",
      "created_at": "",
    },
    click_id: "",
    // animationMap() {return new WeakMap()},
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
